import React from "react";

const BS5_Alerts = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Alerts Component</h2>
      <p>This is the BS5_Alerts component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Alerts;
